import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { ScheduleExportDialogComponent } from "./schedule-export-dialog.component";

@NgModule({
	declarations: [ScheduleExportDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
	exports: [ScheduleExportDialogComponent],
})
export class ScheduleExportDialogModule {}
